import React from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import PageDesigner from './PageDesignerRGL';
import SimplePageDesigner from './SimplePageDesigner';
import PageManagement from './PageManagement';
import WidgetManagement from './WidgetManagement';
import WidgetDesigner from './WidgetDesigner';
import PreviewMode from './PreviewMode';


class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('🔥 ErrorBoundary caught error:', error, errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 20, backgroundColor: '#ffebee', color: '#c62828' }}>
          <h1>❌ Component Error</h1>
          <details style={{ whiteSpace: 'pre-wrap', marginTop: 10 }}>
            <summary>Error Details</summary>
            {this.state.error && this.state.error.toString()}
            <br />
            {this.state.errorInfo && this.state.errorInfo.componentStack}
          </details>
        </div>
      );
    }

    return this.props.children;
  }
}

const SCADARouter = () => {
  const location = useLocation();

  return (
    <Box sx={{ height: '100%', overflow: 'auto' }}>
      <Switch>
        <Route exact path="/scada">
          <Redirect to="/scada/designer" />
        </Route>
        <Route path="/scada/designer">
          <ErrorBoundary>
            <SimplePageDesigner />
          </ErrorBoundary>
        </Route>
        <Route path="/scada/simple-designer">
          <SimplePageDesigner />
        </Route>
        <Route path="/scada/old-designer">
          <PageDesigner />
        </Route>
        <Route path="/scada/pages">
          <PageManagement />
        </Route>
        <Route path="/scada/widgets">
          <WidgetManagement />
        </Route>
        <Route exact path="/scada/widget-designer">
          <WidgetDesigner />
        </Route>
        <Route path="/scada/widget-designer/:widgetId">
          <WidgetDesigner />
        </Route>
        <Route exact path="/scada/preview">
          <PreviewMode />
        </Route>
        <Route path="/scada/preview/:id">
          <PreviewMode />
        </Route>
      </Switch>
    </Box>
  );
};

export default SCADARouter;
